import { router, useForm } from "@inertiajs/react"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import {
  adminAccountPath,
  adminAgentAgentChangelogEntriesPath,
  adminAgentPath,
} from "@/routes"
import type { Agent } from "@/types"

import AgentEntryForm from "./agent-entry-form"

interface AddAgentEntryProps {
  agent: Agent
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function AddAgentEntry({
  agent,
  open,
  onOpenChange,
}: AddAgentEntryProps) {
  const form = useForm({
    agent_changelog_entry: {
      title: "",
      body: "",
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    // @ts-expect-error - Route helper type definition doesn't match implementation
    form.post(adminAgentAgentChangelogEntriesPath({ agent_id: agent.uid }), {
      onSuccess: () => {
        form.reset()
        onOpenChange(false)
        router.reload({ only: ["agent"] })
      },
    })
  }

  function handleCancel() {
    form.reset()
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Post update</DialogTitle>
          <DialogDescription>
            Post an update about{" "}
            <a
              href={adminAgentPath({ id: agent.uid })}
              className="underline"
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                e.preventDefault()
                router.visit(adminAgentPath({ id: agent.uid }))
              }}
            >
              {agent.name}
            </a>
            . This will appear on the agent page for the{" "}
            {agent.account_uid && agent.account ? (
              <a
                href={adminAccountPath({ id: agent.account_uid })}
                className="underline"
                onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault()
                  router.visit(adminAccountPath({ id: agent.account_uid! }))
                }}
              >
                {agent.account.name} account
              </a>
            ) : (
              "account"
            )}
            .
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit}>
          <AgentEntryForm
            form={form}
            onCancel={handleCancel}
            submitLabel="Publish"
          />
        </form>
      </DialogContent>
    </Dialog>
  )
}
